export default __webpack_public_path__ + "d5863131a6600107ac5db14dc6a90cf1.svg";